import AWS from 'aws-sdk';

const S3_BUCKET = "sutra-froala";
const REGION = "us-west-1";

export const uploadFileToS3 = async (accessKeyId, secretAccessKey, file, options = {}) => {
  const s3 = new AWS.S3({
    accessKeyId: accessKeyId,
    secretAccessKey: secretAccessKey,
    region: REGION
  });
  const { folder = 'uploads', onProgress } = options;
  
  const fileName = `${folder}/${Date.now()}_${file.name.replace(/[^a-zA-Z0-9.]/g, '_')}`;
  
  const params = {
    Bucket: S3_BUCKET,
    Key: fileName,
    Body: file,
    ContentType: file.type,
    ACL: 'public-read'
  };

  try {
    const data = await s3.upload(params)
      .on('httpUploadProgress', (progress) => {
        const percent = Math.round((progress.loaded / progress.total) * 100);
        if (onProgress) onProgress(percent);
      })
      .promise();

    return data.Location;
  } catch (error) {
    console.log('Error uploading to S3:', error);
    throw error;
  }
};